var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "close-order" },
    [
      _c(
        "el-radio-group",
        {
          model: {
            value: _vm.radio,
            callback: function ($$v) {
              _vm.radio = $$v
            },
            expression: "radio",
          },
        },
        _vm._l(
          _vm.dictionaries.order_main_close_reason,
          function (item, index) {
            return _c(
              "el-radio",
              { key: index, attrs: { label: item.dictId } },
              [_vm._v(_vm._s(item.dictName))]
            )
          }
        ),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }